import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成
var path = process.env.VUE_APP_BASE_API;
import { getUserList, setUserAuthority, register, deleteUser as _deleteUser, resetPassword as _resetPassword } from "@/api/user";
// import { getAuthorityList } from "@/api/authority";
import infoList from "@/mixins/infoList";
import { mapGetters } from "vuex";
import CustomPic from "@/components/customPic";
import ChooseImg from "@/components/chooseImg";
export default {
  name: "Api",
  mixins: [infoList],
  components: {
    CustomPic: CustomPic,
    ChooseImg: ChooseImg
  },
  data: function data() {
    return {
      listApi: getUserList,
      path: path,
      authOptions: [],
      addUserDialog: false,
      userInfo: {
        username: "",
        password: "",
        nickName: "",
        headerImg: "",
        authorityId: ""
      },
      rules: {
        username: [{
          required: true,
          message: this.$t('user.check-error-empty-username'),
          trigger: "blur"
        }, {
          type: 'email',
          message: this.$t('user.check-error-incorrect-email'),
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: this.$t('user.check-error-empty-password'),
          trigger: "blur"
        }, {
          min: 6,
          message: this.$t('user.check-error-length'),
          trigger: "blur"
        }],
        nickName: [{
          required: true,
          message: this.$t('user.check-error-empty-name'),
          trigger: "blur"
        }],
        authorityId: [{
          required: true,
          message: "TODO",
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters("user", ["token"])),
  methods: {
    onSubmit: function onSubmit() {
      this.getTableData();
    },
    openHeaderChange: function openHeaderChange() {
      this.$refs.chooseImg.open();
    },
    setOptions: function setOptions(authData) {
      this.authOptions = [];
      this.setAuthorityOptions(authData, this.authOptions);
    },
    setAuthorityOptions: function setAuthorityOptions(AuthorityData, optionsData) {
      var _this = this;
      AuthorityData && AuthorityData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            children: []
          };
          _this.setAuthorityOptions(item.children, option.children);
          optionsData.push(option);
        } else {
          var _option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName
          };
          optionsData.push(_option);
        }
      });
    },
    deleteUser: function deleteUser(row) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _deleteUser({
                id: row.ID
              });
            case 2:
              res = _context.sent;
              if (res.code == 0) {
                _this2.getTableData();
                row.visible = false;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    enterAddUserDialog: function enterAddUserDialog() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.$refs.userForm.validate( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!valid) {
                          _context2.next = 8;
                          break;
                        }
                        _context2.next = 3;
                        return register(_this3.userInfo);
                      case 3:
                        res = _context2.sent;
                        if (res.code == 0) {
                          _this3.$message({
                            type: "success",
                            message: _this3.$t('common.msg.create-success')
                          });
                        }
                        _context2.next = 7;
                        return _this3.getTableData();
                      case 7:
                        _this3.closeAddUserDialog();
                      case 8:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    closeAddUserDialog: function closeAddUserDialog() {
      this.$refs.userForm.resetFields();
      this.addUserDialog = false;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      this.userInfo.headerImg = res.data.file.url;
    },
    addUser: function addUser() {
      this.addUserDialog = true;
    },
    changeAuthority: function changeAuthority(row) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return setUserAuthority({
                uuid: row.uuid,
                authorityId: row.authority.authorityId
              });
            case 2:
              res = _context4.sent;
              if (res.code == 0) {
                _this4.$message({
                  type: "success",
                  message: _this4.$t('user.role-setting-success')
                });
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    resetPwd: function resetPwd(row) {
      var _this5 = this;
      this.$confirm(this.$t('user.reset-confirm') + ' ' + row.userName + '?', this.$t('common.msg.prompt-title'), {
        confirmButtonText: this.$t('common.button.confirm'),
        cancelButtonText: this.$t('common.button.cancel'),
        type: 'warning'
      }).then(function () {
        _this5.resetPassword(row);
      });
    },
    resetPassword: function resetPassword(row) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _resetPassword({
                username: row.userName
              });
            case 2:
              res = _context5.sent;
              if (res.code == 0) {
                _this6.$message({
                  type: "success",
                  message: _this6.$t('user.role-setting-success')
                });
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  },
  created: function created() {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _this7.getTableData();
            // const res = await getAuthorityList({ page: 1, pageSize: 999 });
            // this.setOptions(res.data.list);
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};